/* eslint-disable react-refresh/only-export-components --
 * Context module: Provider + hook are intentionally co-located.
 */
import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

const LayoutDerivedContext = createContext<Readonly<Record<string, number>>>(
  {}
);

export function LayoutDerivedProvider({
  value,
  children,
}: {
  value: Readonly<Record<string, number>>;
  children: ReactNode;
}) {
  return (
    <LayoutDerivedContext.Provider value={value}>
      {children}
    </LayoutDerivedContext.Provider>
  );
}

export function useLayoutDerived(): Readonly<Record<string, number>> {
  return useContext(LayoutDerivedContext);
}
